"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var material_1 = require("@mui/material");
var ConnectionStyles_1 = require("@/frontend/react/connections/ConnectionStyles");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var RequestHelpBox_1 = __importDefault(require("./RequestHelpBox"));
function Recruiter() {
    var recruiterParam = (0, react_router_dom_1.useParams)().recruiterId;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var _a = (0, react_query_1.useQuery)(['recruiter', recruiterParam], function () {
        return axios_1.default.get("/data/recruiters/".concat(recruiterParam)).then(function (result) { return result.data; });
    }), isLoading = _a.isLoading, recruiter = _a.data;
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(material_1.LinearProgress, {});
    }
    if (!recruiter) {
        return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: isSmallScreen ? ConnectionStyles_1.containerStyles.containerMobile : ConnectionStyles_1.containerStyles.container }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.topBar }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", variant: "h5", flexGrow: "1" }, { children: trans_1.default.get('labels.frontend.general.oops') })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.innerContainer }, { children: trans_1.default.get('labels.frontend.recruiting.does_not_exist') }))] })));
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ id: "chatWindow", sx: isSmallScreen ? ConnectionStyles_1.containerStyles.containerMobile : ConnectionStyles_1.containerStyles.container }, { children: recruiter && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.topBar }, { children: [(0, jsx_runtime_1.jsx)(material_1.Avatar, { src: recruiter.profile.profilePicture, alt: recruiter.name }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", variant: "h5", flexGrow: "1" }, { children: recruiter.name }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.innerContainer }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: recruiter.profile.tagline }) })), (0, jsx_runtime_1.jsx)(RequestHelpBox_1.default, { recruiterId: recruiter.id })] })) })));
}
exports.default = Recruiter;
